import React from "react";
import { formHasScenePlan } from "../scenePlan";
import { collectMentionableAssets } from "../mentionAssets";
import MentionPromptInput from "./MentionPromptInput";

/** Prompt textarea with @-mentions for uploaded image/video references. */
export default function PromptField({
  form,
  onChange,
  lang,
  textFieldProps = {},
}) {
  const set = (patch) => onChange({ ...form, ...patch });
  const sceneMode = formHasScenePlan(form);
  const assets = React.useMemo(() => collectMentionableAssets(form), [form]);

  return (
    <MentionPromptInput
      label={
        sceneMode
          ? lang?.videoStudioSharedBriefLabel || "Shared brief (all scenes)"
          : lang?.videoStudioPromptLabel || "Prompt"
      }
      helperText={
        sceneMode
          ? lang?.videoStudioSharedBriefHint ||
            "With multiple scenes, this shared brief is visuals only (never spoken). Put spoken lines in each Scene (Dialogue: / Voiceover: / Name: / @Image: …)."
          : undefined
      }
      value={form.prompt || ""}
      onChange={(prompt) => set({ prompt })}
      assets={assets}
      minRows={textFieldProps.minRows || 4}
      placeholder={textFieldProps.placeholder}
      lang={lang}
    />
  );
}
